<template lang="pug">
  .multiline-text-field
    textarea(
      :value="value"
      :placeholder="placeholder"
      :required="required"
      @input="$emit('input', $event.target.value)"
    )
</template>

<style lang="scss">
textarea {
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  props: {
    value: { type: String },
    placeholder: { type: String },
    required: { type: Boolean, default: true },
  },
}
</script>
